import { Box, Divider, Flex } from "@chakra-ui/react";
import PageLoader from '../../global/components/helper-components/components/PageLoader';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import ReactIconDisplay from '../../global/components/helper-components/components/ReactIconDisplay';
import { MdOutlineGeneratingTokens } from 'react-icons/md';
import { IoIosArrowDroprightCircle } from 'react-icons/io';
import useLaunchdeckModal from '../../global/hooks/use-launchdeck-modal';
import LaunchdeckFormInput from '../../forms/TextInputField/components/LaunchdeckFormInput';


export function CreateDsrForm({
  createDsrForm,
  error,
  showLoader,
  onChangeHandler,
  handleClickCloseEditActionModal,
  handleMoveToBrandingStep,
  newUserTourIsActive
}) {
  
  const titleCharacterLimit = 100;
  const { openLaunchdeckModal } = useLaunchdeckModal();

  const handleSwitchToAiCreation = () => {
    openLaunchdeckModal('create-room-with-ai-form')
  }

  if (showLoader) {
    return (
      <Box w="100%" align="center" >
        <Box px='1em'>
          <PageLoader />
        </Box>
      </Box>
    )
  }

  if (!showLoader) {
    return (
      <Box m='1.5em' w="100%" align="center" >

        <Flex mb='2em' bgGradient="linear(to-r, #FF2847, #29ABE2)" rounded='0.25em' p='0.5em'>
          <Flex data-driver="step-5" gap={4} p='0.1em' w='100%' justify='space-between' align='center' cursor={!newUserTourIsActive && 'pointer'} onClick={() => !newUserTourIsActive && handleSwitchToAiCreation()}>
            <Flex gap={4}>
              <ReactIconDisplay reactIcon={MdOutlineGeneratingTokens} color='white' fontSize='1em' mr='0em' />
              <Box fontSize='0.75em' color='white'>
                Need inspiration? Start a Room with AI with your own documents
              </Box>
            </Flex>
            <ReactIconDisplay reactIcon={IoIosArrowDroprightCircle} color='white' fontSize='1em' mr='0em' />
          </Flex>
        </Flex>

        <Box data-driver="step-4">
          <Box mb='1.5em'>
            <LaunchdeckFormInput
              label='Room name'
              name={'dsrTitle'}
              onChange={onChangeHandler}
              value={createDsrForm.dsrTitle}
              placeholder="e.g. Request for quotation & product intro"
              isRequired={true}
              charLimit={titleCharacterLimit}

              errorLogic={error === 'dsrTitle'}
              errorMessage={`Give your Room a good name`}
            />
          </Box>

          <Divider my='2em' />

          <Flex mt='1em' mb='1.5em' direction='column' w='100%' align='center' gap='1.25em'>
            <LaunchdeckFormInput
              label='Client name'
              name={'dsrClientName'}
              onChange={onChangeHandler}
              value={createDsrForm.dsrClientName}
              placeholder="e.g. Traders Joe"

              errorLogic={error === 'dsrClientName'}
              errorMessage={'Something wrong with capturing the client name.'}
            />

            <LaunchdeckFormInput
              label='Client website'
              name={'dsrClientWebsite'}
              onChange={onChangeHandler}
              value={createDsrForm.dsrClientWebsite}
              placeholder="e.g. https://www.traderjoes.com"

              errorLogic={error === 'dsrClientWebsite'}
              errorMessage={`Invalid website URL. Correct URL example: 'https://www.google.com'`}
            />

          </Flex>
        </Box>

        <Flex w='100%' mt='2em' py='0.625em'>
          <Flex justify='flex-end' w='100%'>
            {/* <LaunchdeckButton name='closeCreateActionModal' borderColor="gray.500" label='Cancel' fontSize='0.8em' py='0.4em' onClick={handleClickCloseEditActionModal} /> */}
            <LaunchdeckButton label='Proceed' borderRadius='300px' fontSize="0.8em" bg='brand.500' color='gray.50' py='0.4em' onClick={handleMoveToBrandingStep} />
          </Flex>
        </Flex>
      </Box>
    )
  }
}
